module.exports = "<div class=\"img-container-outer\" *ngIf=\"image\">\n  <div class=\"img-contaienr-inner\">\n    <button class=\"clear flush-icon icon-remove remove-btn\"\n            (click)=\"clear()\">\n      <span class=\"sr-only\">Remove Image</span>\n    </button>\n    <img [src]=\"image\">\n  </div>\n</div>\n<input type=\"file\"\n       #imageInputField\n       imageUpload\n       (imageSelected)=\"selected($event)\"\n       [resizeOptions]=\"resizeOptions\">\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/survey/photo-question/photo-question.component.html
// module id = 286
// module chunks = 1